import { render, staticRenderFns } from "./MainNavbar.vue?vue&type=template&id=5b832932&scoped=true"
import script from "./MainNavbar.vue?vue&type=script&lang=ts"
export * from "./MainNavbar.vue?vue&type=script&lang=ts"
import style0 from "./MainNavbar.vue?vue&type=style&index=0&id=5b832932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b832932",
  null
  
)

export default component.exports